export const tokenApiPaths = {
    persons: 'persons',
    images: 'images',
    personTokensStatus: 'person-tokens/status',
} as const;
